"use strict";

define(['app', './models/Attachment', './views/iv_Attachment', './../../libs/translationsUtils/modal', 'magnific-popup'], function (app, AttachmentModel, AttachmentView, TranslationModalSanatizer) {
  var AttachmentsCollection = app.Backbone.Collection.extend({
    model: AttachmentModel
  });
  return app.Marionette.CollectionView.extend({
    tagName: 'ul',
    childView: AttachmentView,
    childViewOptions: function childViewOptions() {
      return {
        labels: this.options.labels,
        input_name: this.options.input_name
      };
    },
    options: {
      labels: {
        place: 'Place in text',
        attachment: 'Show as attachment',
        delete: 'Delete',
        verifyError: 'File could not be verified, please upload it again.',
        verifyDenial: 'Sorry, we couldn’t upload your file because we believe it may contain a virus. Please check your file with another virus scanner to be safe.'
      }
    },
    onRender: function onRender() {
      var translations = app.translations ? TranslationModalSanatizer(app.translations.get('modal')) : {};

      var opts = app._.extend({
        delegate: 'a.popup',
        gallery: {
          enabled: true
        }
      }, translations);

      app.$(this.$el).magnificPopup(opts);
    },
    onAttachmentAdd: function onAttachmentAdd(data) {
      this.collection.add(data);
    },
    onAttachmentSet: function onAttachmentSet(id, data) {
      data.id = id;
      if (data.type === 'image') data.isVerified = true;

      var _model = this.collection.get(id);

      if (_model) {
        _model.set(data);
      } else {
        this.collection.add(data);
      }
    },
    onAttachmentRemove: function onAttachmentRemove(id) {
      var model = this.collection.get(id);

      if (model) {
        model.trigger('destroy', model, model.collection);
      }
    },
    onAttachmentCheckfilecontents: function onAttachmentCheckfilecontents(id, data) {
      var self = this;
      var timeout = 300000;
      var endTime = Number(new Date()) + timeout;
      var interval = 2000;

      var pollFileInspection = function pollFileInspection() {
        var xhrListener = function xhrListener() {
          if (xhr.status === 200) {
            self.onCheckfilecontentsSuccess(id);
          } else if (Number(new Date()) < endTime) {
            setTimeout(pollFileInspection, interval);
          } else {
            self.onCheckfilecontentsFail(id, new Error('Timed out checking file contents'));
          }
        };

        var xhr = new XMLHttpRequest(); // eslint-disable-line

        xhr.addEventListener('load', xhrListener);
        xhr.open('GET', data.source);
        xhr.send();
      };

      pollFileInspection();
    },
    onCheckfilecontentsSuccess: function onCheckfilecontentsSuccess(id) {
      var _model = this.collection.get(id);

      _model.set('isVerified', true);

      this.triggerMethod('attachment:verified');
    },
    onCheckfilecontentsFail: function onCheckfilecontentsFail(id, err) {
      var _model = this.collection.get(id);

      if (_model) {
        _model.trigger('destroy', _model, _model.collection);
      }

      this.triggerMethod('attachment:verified');
      this.triggerMethod('attachment:verify:timeout', err);
    },
    attachmentsFileSize: function attachmentsFileSize() {
      var filesSize = 0;
      this.collection.each(function (model) {
        filesSize += model.get('file_size');
      });
      return filesSize;
    },
    initialize: function initialize(options) {
      var self = this;
      var id = app.$(this.$el).closest('form').attr('id');
      this.collection = new AttachmentsCollection([]);

      if (!app.translations) {
        app.events.commands.setHandler('translations:mounted', function () {
          self.render();
        });
      }

      app.events.commands.setHandler('attachment:' + id + ':add', function (data) {
        self.triggerMethod('attachment:add', data);
      });
      app.events.commands.setHandler('attachment:' + id + ':set', function (id, data) {
        self.triggerMethod('attachment:set', id, data);
      });
      app.events.commands.setHandler('attachment:' + id + ':remove', function (id) {
        self.triggerMethod('attachment:remove', id);
      });

      if (options.attachments && Object.keys(options.attachments).length) {
        Object.keys(options.attachments).forEach(function (i) {
          var attachment = options.attachments[i];
          attachment.isVerified = true;

          if (attachment.type === 'image') {
            attachment.source = options.imageAttachmentCdn + attachment.source;
            attachment.source_thumb = options.imageAttachmentCdn + attachment.source_thumb;
          }

          self.onAttachmentSet(attachment.id, attachment);
        });
      }
    }
  });
});